// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__14Ud8","content":"Contact_content__TIUlJ","desc_2":"Contact_desc_2__GLN9C","linkOut":"Contact_linkOut__NM5qe"};